import { render } from "./BulkUpdater.vue?vue&type=template&id=2953c31a&scoped=true&ts=true"
import script from "./BulkUpdater.vue?vue&type=script&lang=ts"
export * from "./BulkUpdater.vue?vue&type=script&lang=ts"

import "./BulkUpdater.vue?vue&type=style&index=0&id=2953c31a&scoped=true&lang=css"

import exportComponent from "/runner/_work/OrderpadConfigurationWeb/OrderpadConfigurationWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2953c31a"]])

export default __exports__